import { createActions } from 'redux-actions';

export const {
  // GET PROFILE INFO
  getProfileInfo,
  getProfileInfoSuccess,
  getProfileInfoFailure,
  // UPDATE PROFILE INFO
  updateProfileInfo,
  updateProfileInfoSuccess,
  updateProfileInfoFailure,
} = createActions(
  'GET_PROFILE_INFO',
  'GET_PROFILE_INFO_SUCCESS',
  'GET_PROFILE_INFO_FAILURE',
  'UPDATE_PROFILE_INFO',
  'UPDATE_PROFILE_INFO_SUCCESS',
  'UPDATE_PROFILE_INFO_FAILURE'
);
